var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{},[_vm._l((_vm.myEntityConfig.rowsToShowOnEntityPage),function(filterKey,i){return [(filterKey === null)?_c('v-divider',{key:'divider-'+i,staticClass:"my-1"}):_c('entity-datum-row',{key:'data-'+filterKey,staticClass:"px-4 pb-1",attrs:{"filter-key":filterKey,"data":_vm.data,"type":_vm.type}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }